<template>

    <div v-if="loading">
        <ScaleLoader />
    </div>
    <div class="card" v-else>
        <div class="grid">
            <div class=" flex-1 col-2">
                <div class="flex justify-content-start">
                    <Button class="p-button p-button-success" type="button" icon="pi pi-book" label="Header" @click="onShowHeaderDialog"/>
                </div>
            </div>
            <div class="flex justify-content-center align-content-center col-7 grid">
                <div class="col-6"><b>Name</b>: {{datasource.name}}</div>
                <div class="col-4"><b>Code</b>: {{datasource.code}}</div>
                <div class="col-2">
                    Sharable: <b>{{datasource.sharable ? 'Yes' : 'No'}}</b>
                </div>
            </div>
            <div class=" flex-1 col-3">
                <div class="flex justify-content-end">
                    <Button class="mr-2 p-button p-button-info" type="button" icon="pi pi-question-circle" label="Help" @click="onShowHelper"/>
                    <Button
                        class="mr-2 p-button p-button-success"
                        type="button"
                        icon="pi pi-copy"
                        label="Copy"
                        @click="onCopy"
                        :loading="cloningDatasource"
                    />
                    <Button class="p-button p-button-warning" type="button" icon="pi pi-times" label="Cancel" @click="onCancelDatasource"/>
                </div>
            </div>
        </div>

        <div class="grid">
            <div class="col-8">
                <Panel header="Datasource" class="mb-3">

                        <OrganizationChart
                            :value="datasourceSchema"
                            @node-select="onNodeSelected"
                            @node-unselect="onNodeUnSelected"
                            selection-mode="single"
                            style="overflow:scroll;"
                            v-model:selectionKeys="selection"
                        >
                            <template #default="slotProps">
                                <div style="position:absolute; top: 0; right: 0">
                                    {{slotProps.node.key}}
                                </div>

                                <div class="flex flex-column align-items-center mb-2">
                                    <i class="pi pi-cog" style="font-size: 1rem"/>
                                </div>

                                <div class="flex flex-column align-items-center" v-if="slotProps.node.details">
                                    Procedure:
                                    <b v-if="slotProps.node.details.procedure === 'attribute'">
                                        Attribute
                                    </b>
                                    <b v-else-if="slotProps.node.details.procedure === 'assessment_date'">
                                        Assessment Date
                                    </b>
                                    <b v-else-if="slotProps.node.details.procedure === 'assessment_user_age'">
                                        Assessment User Age
                                    </b>
                                    <b v-else-if="slotProps.node.details.procedure === 'user_today_age'">
                                        User Today Age
                                    </b>
                                    <b v-else-if="slotProps.node.details.procedure === 'assessment_code'">
                                        Assessment Code
                                    </b>
                                    <b v-else-if="slotProps.node.details.procedure === 'archive_status'">
                                        Archive Status
                                    </b>
                                    <b v-else-if="slotProps.node.details.procedure === 'without_assessment_code'">
                                        Without Assessment Code
                                    </b>
                                    <b v-else-if="slotProps.node.details.procedure === 'user_list'">
                                        User List
                                    </b>
                                    <b v-else>
                                        {{slotProps.node.details.procedure}}
                                    </b>
                                </div>

                                <div v-if="slotProps.node.details">
                                    <div class="grid mb-0">
                                        <div class="col-12">
                                            <div class="grid mb-0">
                                                <template v-if="slotProps.node.details.tag_id && slotProps.node.details.tag_id.length > 0">
                                                    <div class="col-5">tag_id</div>
                                                    <div class="col-7">{{slotProps.node.details.tag_id}}</div>
                                                </template>
                                                <template v-if="slotProps.node.details.attribute_code && slotProps.node.details.attribute_code.length > 0">
                                                    <div class="col-5">Attribute:</div>
                                                    <div class="col-7">{{getAttributeLabelFromCode(slotProps.node.details.attribute_code)}}</div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="slotProps.node.details.operator"
                                        class="flex flex-column align-items-center"
                                    >
                                        <b>{{slotProps.node.details.operator}}</b>
                                    </div>

                                    <div
                                        v-if="slotProps.node.details.value"
                                        class="flex flex-column align-items-center"
                                    >
                                        <b v-if="slotProps.node.details.procedure === 'assessment_date'">
                                            {{dateFormat(slotProps.node.details.value)}}
                                        </b>
                                        <b v-else-if="slotProps.node.details.procedure === 'user_list'">
                                            &nbsp;
                                        </b>
                                        <b v-else-if="slotProps.node.details.procedure === 'last_attribute' || slotProps.node.details.procedure === 'attribute' || slotProps.node.details.procedure === 'first_attribute'">
                                            {{getAttributeValueFromCode(slotProps.node.details.attribute_code, slotProps.node.details.value)}}
                                        </b>
                                        <b v-else-if="DateTime.fromISO(slotProps.node.details.value).isValid">
                                            {{DateTime.fromISO(slotProps.node.details.value).setLocale('en-GB').toLocaleString({
                                            weekday: 'short',
                                            month: 'short',
                                            day: '2-digit',
                                            year: 'numeric',
                                        })}}
                                        </b>
                                        <b v-else>
                                            {{getAttributeValueFromCode(slotProps.node.details.attribute_code, slotProps.node.details.value)}}
                                        </b>
                                    </div>
                                </div>
                            </template>
                            <template #connector="slotProps">
                                <div style="position:absolute; top: 0px; right: 0px">
                                    {{slotProps.node.key}}
                                </div>

                                <div class="flex flex-column align-items-center mb-2">
                                    <i class="pi pi-share-alt" style="font-size: 1rem" />
                                </div>

                                <div class="flex flex-column align-items-center">
                                    <span>{{ slotProps.node.label }}</span>
                                </div>
                            </template>
                        </OrganizationChart>
                    <hr />

                </Panel>
            </div>
            <div class="col-4">
                <Panel header="Overview" class="mb-3">

                    <ScrollPanel
                        style="height: 300px"
                        v-if="warningsOrErrors.length"
                    >
                        <DataTable
                            :value="warningsOrErrors"
                            :rowHover="true"
                            selectionMode="single"
                            :loading="loading || saving"

                            :totalRecords="warningsOrErrors.length"
                            responsiveLayout="scroll"
                            :rowsPerPageOptions="[2, 5, 10]"

                        >
                            <Column field="cause" :header="`Issue(s) (tot: ${warningsOrErrors.length})`" />
                            <Column style="width: 2rem" header="Edit" >
                                <template #body="slotProps">
                                    <!--<Button icon="pi pi-user" label="Users" :badge="slotProps.data.users.length.toString()" class="m-2 p-button p-button-warning" v-tooltip="'Show User Group members'" @click="toggleUserGroupMemberWindows(slotProps.data.users, slotProps.data.name)"> </Button>-->
                                    <Button
                                        icon="pi pi-pencil"
                                        class="p-button-rounded p-button-info mr-2"
                                        @click="onIssueClick(slotProps.data.node)"
                                        v-tooltip="'Edit Element'"
                                    />
                                </template>
                            </Column>
                        </DataTable>
                    </ScrollPanel>

                    <hr />

                    <div v-if="warningsOrErrors.length === 0">
                        <div v-if="saving">
                            <ScaleLoader />
                        </div>
                        <div v-else class="grid">
                            <div class="flex col-1 align-items-center">
                                <i class="pi pi-check" style="color: green; font-size: 1.5rem"></i>
                            </div>
                            <div class="flex col-11 align-items-center">
                                No issues found!
                            </div>
                        </div>
                    </div>

                    <template v-if="!usergroupsLoading">

                        <div v-if="usergroups && usergroups.length > 0" >
                            <Divider />

                            <DataTable :value="usergroups">
                                <template #header>
                                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                                        <span class="text-xl text-900 font-bold">User Groups based on this DataSource:</span>
                                        <Button
                                            icon="pi pi-refresh"
                                            class="p-button-rounded p-button-help p-button-outlined"
                                            v-tooltip="'Refresh the user groups'"
                                            @click="loadLinkedUserGroups(usedByUserGroups)"
                                        />
                                    </div>
                                </template>

                                <Column field="userGroup.id" header="Id"></Column>
                                <Column field="userGroup.name" header="Name"></Column>

                                <Column field="users" header="Users" ref="users" key="userGroup.id">
                                    <template #body="slotProps">
                                        <Button
                                            icon="pi pi-user"
                                            label="Users"
                                            :badge="slotProps.data.users.length.toString()"
                                            class="m-2 p-button p-button-warning"
                                            v-tooltip="'Show User Group members'"
                                            @click="toggleUserGroupMemberWindows(slotProps.data.users, slotProps.data.name)"
                                        />
                                    </template>
                                </Column>
                                <Column field="userGroup.id" header="Edit">
                                    <template #body="slotProps">
                                        <Button
                                            icon="pi pi-pencil"
                                            class="p-button-rounded p-button-success mr-2"
                                            v-tooltip="'Edit User Group'"
                                            @click="editUserGroup(slotProps.data.userGroup.id)"
                                            :disabled="!checkUserPermission(UserPermissions.WRITE_USER_GROUP)"
                                        />
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <template v-else>

                            <div class="col-1 flex align-items-center">
                                <i class="pi pi-exclamation-triangle" style="color: red; font-size: 1.5rem"></i>
                            </div>
                            <div class="col-7 flex align-items-center">
                                No User Groups found:<br /> Would you like to create one?
                            </div>
                            <div class="col-4 flex align-items-center">
                                <Button
                                    class="mr-2 p-button p-button-info"
                                    type="button"
                                    icon="pi pi-plus"
                                    label="Create"
                                    @click="onCreateUserGroup"
                                    :disabled="userGroupSaving"
                                    :loading="userGroupSaving"
                                />
                            </div>

                        </template>

                    </template>
                    <div v-if="usergroupsLoading" class="ml-3">
                        <ProgressSpinner style="width: 25px; height: 25px" strokeWidth="8" fill="transparent"
                                         animationDuration=".5s" aria-label="Custom ProgressSpinner" />
                        Loading User Groups...
                    </div>
                </Panel>
            </div>
        </div>
    </div>

    <DatasourceHeader
        :showHeaderDialog="showHeaderDialog"
        :code="datasource.code"
        :name="datasource.name"
        :sharable="datasource.sharable"
        :description="datasource.description"
        :saving="saving"
        :datasourceCouldBeShared="datasourceCouldBeShared"
        @onSaveDatasource="onSaveDatasource"
        @onHideHeaderDialog="onHideHeaderDialog"
    />

    <DatasourceNodeEdit
        :showEditDialog="showEditNodeDialog"
        :nodeSelected="nodeSelected"
        :saving="saving"
        :attributeList="attributeList"
        :assessmentList="assessmentList"
        :tagList="tagList"
        :sharable="datasource.sharable"
        @onHideNodeEditDialog="onHideNodeEditDialog"
        @onCreateUpdateNode="onCreateUpdateNode"
        @onDeleteNode="onDeleteNode"
    />

    <Dialog v-model:visible="showHelpDialog" modal :style="{ width: '650px' }" header="Datasource help" @hide="showHelpDialog = false">
        <Accordion :activeIndex="0">
            <AccordionTab header="How to start">
                To change <b>Datasource</b> header information, click on the <b>Header</b> button in the upper left corner.<br />
                To start configure the Datasource, click on a node of the graph displayed in the <b>Logical Overview</b>.
            </AccordionTab>
            <AccordionTab header="Logical Overview">
                There are two different types of nodes you can click to edit:
                <ol>
                    <li>
                        <i class="pi pi-share-alt" style="font-size: 1rem" /> - <b>Connector</b> -
                        A container that groups multiple conditions together.
                    </li>
                    <li>
                        <i class="pi pi-cog" style="font-size: 1rem" /> - <b>Procedure</b> -
                        A single condition, such as "Age greater than or equal to (>=) 42."
                    </li>
                </ol>
                Once that the type is set, it cannot be changed and the node must be deleted and re-created.
            </AccordionTab>
            <AccordionTab header="Connectors">
                Here is the list of available connectors:
                <ol>
                    <li>
                        <b>AND</b>: All conditions within this connector must be true. For example,
                        <b>V02 > 38</b>
                        AND
                        <b>age > 40</b>
                        means both conditions must be met. If only one condition is met or neither is met,
                        the person will be excluded.
                    </li>
                    <li>
                        <b>OR</b>: The record must meet at least one of the given conditions. For example,
                        <b>age > 18</b>
                        OR
                        <b>age &lt; 80</b>
                        will return all people who were tested in an assessment.
                    </li>
                    <li>
                        <b>NOT</b>: This connector must have exactly one condition.
                        It negates its condition. For example, <b>NOT sex = male</b>
                        means it will include people who declared a sex different from male.
                    </li>
                </ol>
            </AccordionTab>
        </Accordion>

        <template #footer>
            <div class="flex flex-1 justify-content-end">
                <Button class="p-button p-button-success" type="button" icon="pi pi-times" label="Close" @click="showHelpDialog = false"/>
            </div>
        </template>
    </Dialog>


    <Dialog v-model:visible="userGroupWindowsShow" modal>
        <template #header>
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class=" white-space-nowrap">Members of UserGroup: <b>{{userGroupWindowsGroupName}}</b></span>
            </div>
        </template>

        <DataTable :value="userGroupWindowsMembers" :paginator="true" :rows="5" responsiveLayout="scroll">
            <template #empty> No Users available </template>
            <Column field="id" header="ID" />
            <Column field="name" header="Name" />
            <Column field="surname" header="Surname" />
        </DataTable>
    </Dialog>

    <Dialog v-model:visible="clonedDatasourceDisplayWindow" modal>
        <template #header>
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class=" white-space-nowrap">Cloned Datasource</span>
            </div>
        </template>

        <div class="grid">
            <div class="col-10">Go to <b>{{clonedDatasourceName}}</b></div>
            <div class="col-2">
                <Button
                    icon="pi pi-external-link"
                    class="p-button-rounded p-button-success mr-2"
                    @click="goToClone"
                    v-tooltip="'Edit DataSource'"
                />
            </div>
        </div>
    </Dialog>
</template>

<script setup>

import { defineProps, onMounted, ref } from 'vue';
import GlobalRequest from '@/api/global-request';
import useUserComposable from '@/composables/UserComposable';
import { showToast } from '@/helpers/toast-handler';
import DatasourceHeader from '@/products/pha/modules/datasource/components/DatasourceHeader.vue';
import DatasourceNodeEdit from '@/products/pha/modules/datasource/views/DatasourceNodeEdit.vue';
import { DateTime } from 'luxon';
import { UserPermissions } from '@/enums';
import { useRouter } from 'vue-router';

const router = useRouter();

const { checkUserPermission } = useUserComposable();

const { company_id } = useUserComposable();

const props = defineProps({
    id: {
        type: [Number, String],
    },
});

const datasource = ref({
    id: null,
    company_id: null,
    name: '',
    code: '',
    description: '',
    sharable: false,
    links: [],
})

const usergroups = ref([])
const usergroupsLoading = ref(false)

const datasourceSchema = ref({})

const selection = ref({});
const loading = ref(false)
const saving = ref(false)
const showHeaderDialog = ref(false)
const showHelpDialog = ref(false)
const showEditNodeDialog = ref(false)
const nodeSelected = ref({})
const attributeList = ref([])
const assessmentList = ref([])
const tagList = ref([])
const warningsOrErrors = ref([])
const userGroupWindowsShow = ref(false)
const userGroupWindowsGroupName = ref('')
const userGroupWindowsMembers = ref([])
const datasourceCouldBeShared = ref(true)
const userGroupSaving = ref(false)
const usedByUserGroups = ref([])

const clonedDatasourceId = ref(null)
const clonedDatasourceName = ref('')
const clonedDatasourceDisplayWindow = ref(false)
const cloningDatasource = ref(false)

onMounted(async () => {

    loading.value = true

    try {
        // loading attributes, assessments, and so on so that they could be ready when opening the popup.
        await Promise.all([
            loadDataSourceDetails(),
            loadAttributes(),
            loadAssessments(),
        ])

        loading.value = false
    } catch(err) {
        console.log('err', err)
        showToast({}, 'Cannot load Datasource');
    }

});

function getAttributeLabelFromCode(attributeCode) {
    const selectedAttribute = getAttributeFromCode(attributeCode)

    if (selectedAttribute && selectedAttribute.label) {
        return selectedAttribute.label
    } else {
        return attributeCode
    }
}

function getAttributeValueFromCode(attributeCode, value) {
    const selectedAttribute = getAttributeFromCode(attributeCode)

    // console.log('value', value)
    // console.log('selectedAttribute', selectedAttribute)

    if (selectedAttribute && selectedAttribute.options) {
        const selectedOption = selectedAttribute.options.find((option) => {
            return option.value == value
        })

        if (selectedOption) {
            return selectedOption.label
        } else {
            return value
        }
    } else {
        return value
    }
}

function getAttributeFromCode(attributeCode) {

    // console.log('attributeCode', attributeCode)

    return attributeList.value.find((item) => {
        return item.code === attributeCode
    })
}

function onCreateUserGroup() {

    userGroupSaving.value = true

    const userGroupToSave = {
        company_id: company_id.value,
        name: datasource.value.name,
        code: datasource.value.code,
        datasource_id: datasource.value.id,
    }

    GlobalRequest
        .postRequest(`/v2/datasource/users`, userGroupToSave)
        .then((response) => {
            if (response.statusCode === 201) {
                loadDataSourceDetails().then(() => {
                    userGroupSaving.value = false
                })
            }
        }).catch((err) => {
            userGroupSaving.value = false
            console.log('err', err)
            showToast({}, 'Cannot load Users');
        });

}

function toggleUserGroupMemberWindows(users, userGroupName) {
    userGroupWindowsShow.value = true;
    userGroupWindowsGroupName.value = userGroupName;
    userGroupWindowsMembers.value = users;
}

function editUserGroup(userGroupId) {
    router.push({ name: 'UpdateDatasourceUserGroups', params: { id: userGroupId } })
}

function loadAssessments() {
    assessmentList.value = []

    return GlobalRequest.getRequest(`/v2/template/assessment`, {
        params: {
            company_id: company_id.value,
            user_profile: 'both',
            default: true,
            paginate: false,
        }
    }).then((response) => {
        if (response.statusCode === 200) {
            if (Object.hasOwn(response, 'data')) {


                response.data.forEach((assessment) => {
                    if (assessment.code && assessment.code.length > 0) {
                        assessmentList.value.push({
                            id: assessment.id,
                            code: assessment.code,
                            description: assessment.description,
                            name: assessment.name,
                        })
                    }
                })
            }
        }
    })
}

function loadAttributes() {
    tagList.value = []
    attributeList.value = []

    return GlobalRequest.getRequest(`/v2/template/attributes`, {
        params: {
            company_id: company_id.value,
            user_profile: 'both',
            default: true,
            used: true,
            paginate: false,
        }
    }).then((response) => {
        if (response.statusCode === 200) {
            if (Object.hasOwn(response, 'data')) {

                if (Array.isArray(response.data)) {
                    response.data.forEach((attribute) => {
                        if (!attribute.label || attribute.label.length === 0) {
                            attribute.label = attribute.code
                        }

                        /**
                         * Date added because of https://ignis-tech.atlassian.net/browse/IG-852
                         * Cant select date attributes in datasource
                         */

                        switch(parseInt(attribute.type)) {
                            case 5:
                            case 7:     //Date
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:

                                //tagList
                                if (Object.hasOwn(attribute, 'tags')) {
                                    attribute.tags.forEach((link) => {
                                        if (Object.hasOwn(link, 'tag')) {

                                            const tag = link.tag

                                            let found = false

                                            if (tagList.value.some(e => e.id === tag.id)) {
                                                found = true
                                            }

                                            if (!found) {
                                                tag.attribute = attribute
                                                tagList.value.push(tag)
                                            }
                                        }
                                    })
                                }

                                attributeList.value.push(attribute)
                                break;
                        }
                    })
                }
            }
        }
    })
}

function onNodeUnSelected() {
    showEditNodeDialog.value = false
    nodeSelected.value = {}
}

function onIssueClick(node) {
    onNodeSelected(node)
}

function onNodeSelected(node) {
    showEditNodeDialog.value = true
    nodeSelected.value = node
}

function onHideNodeEditDialog() {
    showEditNodeDialog.value = false
    selection.value = {}
    nodeSelected.value = {}
}

function buildSchema(links, parent = null) {
    let output = []

    if (typeof links !== 'undefined' && Array.isArray(links)) {
        links.forEach(link => {
            let data = {
                key: link.id,
                label: '',
                type: '',
                styleClass: '',
                parent: parent
            }

            if (link.type === 'connector') {
                data.label = link.logical_operation.toUpperCase()
                data.type = 'connector'
                data.styleClass = 'border-round-xl'

                if (typeof link.links !== 'undefined' && Array.isArray(link.links)) {
                    data.children = buildSchema(link.links, link.id)
                }
            }

            data.details = link

            const isDate = DateTime.fromISO(data.details.value).isValid

            if (link.type === 'procedure') {
                data.label = link.procedure
                data.type = 'procedure'

                if (link.procedure === 'assessment_date') {
                    data.details.value = DateTime.fromISO(data.details.value)
                } else if (link.procedure === 'attribute' && !isDate) {
                    data.details.value = parseInt(data.details.value)
                }
            }

            output.push(data)
        })
    }

    if (output.length === 1 && parent === null) {
        return output[0]
    } else {
        return output
    }
}

function loadDataSourceDetails() {
    if (Object.hasOwn(props, 'id')) {
        return GlobalRequest.getRequest(`/v2/datasource/${props.id}`, {
            params: {
                company_id: company_id.value,
            }
        }).then((response) => {
            if (response.statusCode === 200) {

                if (Object.hasOwn(response, 'data')) {
                    datasource.value.id = response.data.id
                    datasource.value.code = response.data.code
                    datasource.value.company_id = response.data.company_id
                    datasource.value.description = response.data.description
                    datasource.value.name = response.data.name
                    datasource.value.sharable = response.data.sharable !== 0
                    datasource.value.links = response.data.links

                    usedByUserGroups.value = response.data.used_by_user_groups

                    loadLinkedUserGroups(response.data.used_by_user_groups)

                    datasourceCouldBeShared.value = true

                    datasourceSchema.value = buildSchema(response.data.links)

                    checkDatasourceStructure(datasourceSchema.value)
                }
            }
        }).catch((err) => {
            loading.value = false
            console.log('err', err)
            showToast({}, 'Cannot load Datasource');

        });
    }
}

function onSaveDatasource(data) {
    showHeaderDialog.value = false

    datasource.value.code = data.code
    datasource.value.description = data.description
    datasource.value.name = data.name
    datasource.value.sharable = data.sharable

    updateDatasource(datasource.value)
}

function onCreateUpdateNode(data) {
    showEditNodeDialog.value = false

    /*
     * There is always a node already added: the root node. So there are only two cases:
     * 1. the User wants to edit the current note: the id is set.
     * 2. the User wants to add a node: append it to its parent.
     */

    if (data.id && typeof data.id !== 'undefined' && typeof datasourceSchema.value !== 'undefined') {
        /*
         * Case 1: edit
         *
         * The new node must replace the old one.
         */
        replaceNodeById(data.id, datasourceSchema.value.details, data)
    } else {
        /**
         * Case 2: add child
         *
         * The new node must be added as child to the parent.
         */
        addNodeById(data.parent, datasourceSchema.value.details, data)
    }

    datasource.value.links = [datasourceSchema.value.details]

    updateDatasource(datasource.value)
}

function onDeleteNode(data) {
    showEditNodeDialog.value = false

    deleteNode(data.id, datasourceSchema.value.details)

    datasource.value.links = [datasourceSchema.value.details]

    updateDatasource(datasource.value)
}

function checkDatasourceStructure(data, resetData) {
    if (typeof resetData === 'undefined') {
        warningsOrErrors.value = []
    }

    if (Object.hasOwn(data, 'details')) {
        if (Object.hasOwn(data.details, 'type') && Object.hasOwn(data.details, 'logical_operation')) {
            if (data.details.type === 'connector') {
                if (Object.hasOwn(data.details, 'links') && data.details.links.length === 0 ) {
                    warningsOrErrors.value.push({
                        'cause': 'Found connector without children',
                        'node': data,
                    })
                }
            }

            if (data.details.type === 'procedure') {
                const nonSharedProcedure = [
                    'assessment_code',
                    'first_attribute',
                    'last_attribute',
                    'user_list',
                    'without_assessment_code',
                ]

                if (nonSharedProcedure.includes(data.details.procedure)) {
                    warningsOrErrors.value.push({
                        'cause': 'Datasource cannot be shared because incompatible procedure',
                        'node': data,
                    })
                    datasourceCouldBeShared.value = false
                }

                if (data.details.procedure === 'attribute' && ((data.details.assessment_code !== null && data.details.assessment_code.length > 0) || (data.details.attribute_code !== null && data.details.attribute_code.length > 0))) {
                    warningsOrErrors.value.push({
                        'cause': 'Datasource cannot be shared because incompatible procedure',
                        'node': data,
                    })
                    datasourceCouldBeShared.value = false
                }
            }
        }
    }

    if (Object.hasOwn(data, 'children')) {
        data.children.forEach(child => {
            checkDatasourceStructure(child, false)
        })
    }
}

/**
 * Convert any DateTime found in values to date strings
 * @param data
 * @returns {any}
 */
function convertDatasourceDatetimeForSaving(data) {

    let datasourceToSave = {}

    if (Object.hasOwn(data, 'code')) {
        datasourceToSave.code = data.code
    }
    if (Object.hasOwn(data, 'company_id')) {
        datasourceToSave.company_id = data.company_id
    }
    if (Object.hasOwn(data, 'description')) {
        datasourceToSave.description = data.description
    }
    if (Object.hasOwn(data, 'id')) {
        datasourceToSave.id = data.id
    }
    if (Object.hasOwn(data, 'name')) {
        datasourceToSave.name = data.name
    }
    if (Object.hasOwn(data, 'sharable')) {
        datasourceToSave.sharable = data.sharable
    }

    if (Object.hasOwn(data, 'assessment_code')) {
        datasourceToSave.assessment_code = data.assessment_code
    }
    if (Object.hasOwn(data, 'attribute_code')) {
        datasourceToSave.attribute_code = data.attribute_code
    }
    if (Object.hasOwn(data, 'logical_operation')) {
        datasourceToSave.logical_operation = data.logical_operation
    }
    if (Object.hasOwn(data, 'operator')) {
        datasourceToSave.operator = data.operator
    }
    if (Object.hasOwn(data, 'procedure')) {
        datasourceToSave.procedure = data.procedure
    }
    if (Object.hasOwn(data, 'tag_id')) {
        datasourceToSave.tag_id = data.tag_id
    }
    if (Object.hasOwn(data, 'type')) {
        datasourceToSave.type = data.type
    }
    if (Object.hasOwn(data, 'value')) {
        datasourceToSave.value = data.value
    }

    if (Object.hasOwn(data, 'procedure') && Object.hasOwn(data, 'value')) {
        if (data.value instanceof DateTime) {
            datasourceToSave.value = data.value.toFormat('y-LL-dd')
        }

        if (data.procedure === 'user_list') {

            if (typeof data.value === 'string') {
                datasourceToSave.value = JSON.parse(data.value)
            } else {
                datasourceToSave.value = data.value
            }
        }

    }

    if (Object.hasOwn(data, 'links')) {
        datasourceToSave.links = []
        if (data.links) {
            data.links.forEach((link) => {

                datasourceToSave.links.push(convertDatasourceDatetimeForSaving(link))
            })
        }
    }

    return datasourceToSave
}

function updateDatasource(data) {

    //Convert any DateTime found in values to date strings
    const datasourceToSave = convertDatasourceDatetimeForSaving(data)

    saving.value = true

    GlobalRequest
        .patchRequest(`/v2/datasource/${datasourceToSave.id}`, datasourceToSave)
        .then((response) => {
        if (response.statusCode === 200) {

            if (Object.hasOwn(response, 'data')) {
                datasource.value.code = response.data.code
                datasource.value.company_id = response.data.company_id
                datasource.value.description = response.data.description
                datasource.value.name = response.data.name
                datasource.value.sharable = response.data.sharable !== 0
                datasource.value.links = response.data.links

                loadLinkedUserGroups(response.data.used_by_user_groups)

                datasourceCouldBeShared.value = true

                datasourceSchema.value = buildSchema(response.data.links)

                warningsOrErrors.value = []
                checkDatasourceStructure(datasourceSchema.value)
            }
        }
    }).catch((err) => {
        console.log('err', err)
        showToast({}, 'Cannot update the Datasource');
    }).finally(() => {
        saving.value = false
    })

}

function loadLinkedUserGroups(userGroupList) {

    usergroups.value = []

    if (typeof userGroupList !== 'undefined' && Array.isArray(userGroupList) && userGroupList.length > 0) {
        usergroupsLoading.value = true
        userGroupList.forEach((userGroupId) => {
            GlobalRequest.getRequest(`/v2/datasource/users/${userGroupId}`, {
                params: {
                    company_id: company_id.value,
                }
            }).then((response) => {
                if (response.statusCode === 200) {
                    if (Object.hasOwn(response, 'data')) {
                        usergroups.value.push(response.data)
                    }

                    usergroupsLoading.value = false
                }
            }).catch((err) => {
                usergroupsLoading.value = false
                console.log('err', err)
                showToast({}, 'Cannot load UsersGroup');

            })
        })
    }
}

function addNodeById(id, currentNode, newNodeData) {
    let output = null

    if (id && currentNode && typeof id !== 'undefined' && typeof currentNode !== 'undefined') {
        if (currentNode.id === id) {
            currentNode.links.push(newNodeData)

            return currentNode
        } else {
            if (typeof currentNode.links !== 'undefined' && Array.isArray(currentNode.links)) {
                currentNode.links.forEach(link => {

                    // Was already found?
                    if (output === null) {
                        output = addNodeById(id, link, newNodeData)
                    }
                })
            }
        }
    }

    return output
}

function deleteNode(id, currentNode) {
    if (typeof currentNode.links !== 'undefined' && Array.isArray(currentNode.links)) {

        //Removing item from the link list.
        currentNode.links = currentNode.links.filter(function(element) { return element.id !== id })

        currentNode.links.forEach(link => {
            deleteNode(id, link)
        })
    }
}

function replaceNodeById(id, currentNode, newNodeData) {
    let output = null

    if (id && currentNode && typeof id !== 'undefined' && typeof currentNode !== 'undefined') {
        if (currentNode.id === id) {
            currentNode.assessment_code = newNodeData.assessment_code
            currentNode.attribute_code = newNodeData.attribute_code
            currentNode.links = newNodeData.links
            currentNode.logical_operation = newNodeData.logical_operation
            currentNode.operator = newNodeData.operator
            currentNode.procedure = newNodeData.procedure
            currentNode.tag_id = newNodeData.tag_id
            currentNode.type = newNodeData.type
            currentNode.value = newNodeData.value

            return currentNode
        } else {
            if (typeof currentNode.links !== 'undefined' && Array.isArray(currentNode.links)) {
                currentNode.links.forEach(link => {

                    // Was already found?
                    if (output === null) {
                        output = replaceNodeById(id, link, newNodeData)
                    }
                })
            }
        }
    }

    return output
}

function onShowHeaderDialog() {
    showHeaderDialog.value = true
}

function onHideHeaderDialog() {
    showHeaderDialog.value = false
}

function onShowHelper() {
    showHelpDialog.value = true
}

function goToClone() {
    const id = clonedDatasourceId.value
    loading.value = true
    clonedDatasourceDisplayWindow.value = false

    router.replace({ name: 'DataSourceUpdate', params: { id: id } }).then(async () => {
        await Promise.all([
            loadAssessments(),
        ])

        loading.value = false
    })
}

function onCopy() {
    console.log('onCopy')

    const clonedDatasource = {...datasource.value}
    clonedDatasource.name = 'CLONED - '+clonedDatasource.name
    clonedDatasource.id = null

    cloningDatasource.value = true

    clonedDatasourceName.value = clonedDatasource.name

    GlobalRequest
        .postRequest('/v2/datasource/', clonedDatasource)
        .then((response) => {
            console.log('response', response)
            if (response.statusCode === 201) {
                clonedDatasourceId.value = response.data.id
                clonedDatasourceDisplayWindow.value = true
            }
        })
        .finally(() => {
            cloningDatasource.value = false
        })
}

function onCancelDatasource() {
    router.go(-1)
}

function dateFormat(date) {
    if (date instanceof DateTime) {
        // after loading
        return date.setLocale('en-GB').toLocaleString({
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        })
    } else {
        // during saving process:
        // String 2024-06-18

        return DateTime.fromFormat(date, 'y-LL-dd').setLocale('en-GB').toLocaleString({
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        })
    }
}

</script>

<style scoped lang="scss">
.form-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
}

.form-field label {
    margin-bottom: 0.5rem;
}

.mandatory {
    position: relative;
    top: -0.1em;
    font-size: 80%;
    color: rgb(200, 20, 20);
}
</style>